import React from "react";
import Header from "components/ui/company/header/Header";
import Footer from "components/ui/company/footer/Footer";

export default ({ element }) => {

  return (
    <>
      <Header />
      {element}
      {element.type.name !== "_default" && <Footer />}
    </>
  );
};